exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".viewer-toolbar .viewer-next,.viewer-toolbar .viewer-play,.viewer-toolbar .viewer-prev{display:none}.viewer-toolbar{width:200px}.viewer-container{height:auto!important;width:auto!important}.viewer-canvas{display:flex;justify-content:center;align-items:center}.viewer-canvas img{margin:0!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/app/imageViewer/imageViewer.css
 ** module id = 188
 ** module chunks = 0
 **/